import { createContext, useContext } from 'react';
import { ActorRefFrom } from 'xstate';
import { marketView } from '~/features/user/userState.v2.machine';

type MarketActorRef = ActorRefFrom<typeof marketView>;
export const EmployerAccountRefContext = createContext<MarketActorRef | null>(null);

export function useMarketActorRef() {
  const ref = useContext(EmployerAccountRefContext);
  if (!ref) throw new Error('useMarketActorRef must be used within UserState.Provider');
  return ref;
}
